<template>
  <v-row v-if="results" class="pt-5">
    <v-col cols="10" offset="1">
      <v-btn @click="showOverlay()" :class="{ blue: overlay }">{{
        overlayLabel
      }}</v-btn>
    </v-col>
    <v-col cols="10" offset="1" class="results-holder">
      <div
        v-for="ex in collatedScores"
        :key="`collates-${ex.title}`"
        class="mb-10"
        :class="{ 'results-overlay': overlay }"
      >
        <h2 v-if="!overlay" class="mb-2">{{ ex.project }}</h2>
        <h2 v-else class="mb-2">Compiled</h2>
        <ResultsGradient
          v-for="(row, index) in ex.scores"
          :key="`${ex.title}-${row.title}`"
          :title="row.title"
          :hue="210 + index * 30"
          :saturation="50"
          :scores="row.score"
          :project="row.project"
          :users="users.length"
          :min-label="row.minLabel"
          :max-label="row.maxLabel"
          :maxScore="maxScore"
          :overlay="overlay"
          :index="index"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import lodash from "lodash";
import { mapState } from "vuex";
import ResultsGradient from "@/components/results/tov/ResultsGradient";
// import { store } from "@/store.js";
export default {
  name: "ResultsTovSummary",
  data() {
    return {
      intervalId: null,
      ready: false,
      max: 2,
      data: null,
      results: [],
      users: [],
      maxScore: 0,
      overlay: false,
      rows: [
        {
          key: "row1",
          title: "Funny / Serious",
          minLabel: "Funny",
          maxLabel: "Serious",
        },
        {
          key: "row2",
          title: "Formal / Casual",
          minLabel: "Formal",
          maxLabel: "Casual",
        },
        {
          key: "row3",
          title: "Respectful / Irreverant",
          minLabel: "Respectful",
          maxLabel: "Irreverant",
        },
        {
          key: "row4",
          title: "Enthusiastic / Matter of fact",
          minLabel: "Enthusiastic",
          maxLabel: "Matter of fact",
        },
      ],
      collatedResults: [],
      collatedBenchmarks: [],
      collatedScores: [],
      columns: [
        "ex1",
        "ex2",
        "ex3",
        "ex4",
        "ex5",
        "ex6",
        "ex7",
        "ex8",
        "ex9",
        "ex10",
        "ex11",
        "ex12",
      ],
    };
  },
  components: { ResultsGradient },
  props: {
    id: String,
    doc: Object,
  },
  mounted() {
    // this.getList();
    this.getExercise();
  },
  computed: {
    ...mapState(["exTov", "tov", "currentProjectModel"]),
    overlayLabel() {
      return this.overlay ? "Hide overlay" : "Show as overlay";
    },
    filteredList() {
      let list = [];
      this.exTov.forEach((item) => {
        list.push(item.tov);
      });
      return list;
    },
    unit() {
      return this.max / 100;
    },
    grouped() {
      return lodash.groupBy(this.exTov, "index");
    },
    benchmarks() {
      const bm = this.currentProjectModel
        ? this.currentProjectModel.benchmarksOrder
        : [];
      if (bm) {
        const arr = [];
        bm.forEach((x, count) => {
          arr.push({ ...x, ref: `ex${count + 1}` });
        });
        return arr;
      } else {
        return bm;
      }
    },
  },
  methods: {
    showOverlay() {
      this.overlay = !this.overlay;
    },
    getExercise() {
      let ref = fb.tovExCollection.where("pid", "==", this.$route.params.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            items.push(post);
          });
          if (items) {
            this.results = items;
          }
          if (users) {
            this.users = users;
          }
          this.collateResults();
        })
        .catch(function() {});
    },
    collateResults() {
      const arr = [];
      this.results.forEach((row) => {
        this.benchmarks.forEach((col) => {
          this.rows.forEach((el) => {
            arr.push({
              uid: row.uid,
              col: col.ref,
              row: el.key,
              title: el.title,
              project: col.title,
              minLabel: el.minLabel,
              maxLabel: el.maxLabel,
              value: this.getRow(row.uid, col.ref, el.key),
            });
          });
        });
      });
      this.collatedResults = arr;
      this.collateBenchmarks(arr);
    },
    collateBenchmarks(arr) {
      console.log("collate benchmarks");
      this.collatedBenchmarks = lodash.groupBy(arr, "col");
      this.collateScores();
    },
    getScore(val, key) {
      const filteredRows = val.filter((x) => x.row === key);
      let distribution = filteredRows.reduce(
        (acum, cur) =>
          Object.assign(acum, { [cur.value]: (acum[cur.value] | 0) + 1 }),
        {}
      );
      return distribution;
    },
    collateScores() {
      const arr = [];
      Object.entries(this.collatedBenchmarks).forEach(([key, value]) => {
        // Now iterate through each row and get the score across each
        const scores = [];
        this.rows.forEach((row) => {
          const filteredRows = value.filter((x) => x.row === row.key);
          let distribution = filteredRows.reduce(
            (acum, cur) =>
              Object.assign(acum, { [cur.value]: (acum[cur.value] | 0) + 1 }),
            {}
          );

          scores.push({
            title: row.title,
            minLabel: row.minLabel,
            maxLabel: row.maxLabel,
            score: distribution,
          });
        });
        arr.push({
          title: key,
          scores,
          project: this.getProjectName(key),
        });
      });
      this.collatedScores = arr;
      this.getMaxScore();
    },
    getMaxScore() {
      const arr = [];
      this.collatedScores.forEach((item) => {
        item.scores.forEach((score) => {
          Object.values(score.score).forEach((val) => {
            arr.push(val);
          });
        });
      });
      this.maxScore = Math.max(...arr);
    },
    getProjectName(key) {
      const item = this.benchmarks.find((x) => x.ref === key);
      if (item) {
        return item.title;
      }
    },
    getRow(user, col, key) {
      const item = this.results.find((x) => x.uid === user);
      if (item) {
        const ex = item.tov[col];
        if (ex) {
          return ex?.[key];
        }
      }
    },
  },
};
</script>

<style lang="scss">
.results-holder {
  position: relative;
}
.results-overlay {
  position: absolute;
  opacity: 1;
  // mix-blend-mode: screen;
  mix-blend-mode: screen;
  // top: 0;
  // left: 0;
  width: 100%;
}
</style>
